const GC_DOMAINS = ["greencardguide.us", "www.greencardguide.us"];

export function isGCDomain() {
  return GC_DOMAINS.includes(window.location.hostname);
}

/** Returns "/gc" on main domain, "" on greencardguide.us */
export function gcBase() {
  return isGCDomain() ? "" : "/gc";
}

/** Prefix a GC-relative path. gcPath("/faq") → "/gc/faq" or "/faq" */
export function gcPath(path) {
  const base = gcBase();
  if (path === "/") return base || "/";
  return `${base}${path}`;
}

/** Canonical base URL — always immigrationguide.us/gc for now */
export function gcCanonicalBase() {
  return "https://immigrationguide.us/gc";
}
